import { Skeleton } from "@mui/material";
import { FC } from "react";
import { NumberToCZKExtraDigits } from "../../helpers";
import { useTypedTranslation } from "../../hooks";
import { InfoIconModalConfirm } from "../InfoIconModalConfirm";
import * as Styled from "./SharesAccountHeader.styled";

export type SharesAccountHeaderProps = {
    cashValue?: number;
    uninvestedAmount?: number;
    surrenderValue?: number;
    isLoading?: boolean;
    alignTitleLeft?: boolean;
};

export const SharesAccountHeader: FC<SharesAccountHeaderProps> = ({
    cashValue,
    uninvestedAmount,
    surrenderValue,
    isLoading,
    alignTitleLeft,
}) => {
    const { t } = useTypedTranslation();

    if (isLoading) {
        return (
            <Styled.SharesAccountHeaderGrid>
                <Skeleton variant="rectangular" height={120} width="100%" />
                <Skeleton variant="rectangular" height={120} width="100%" />
                <Skeleton variant="rectangular" height={120} width="100%" />
            </Styled.SharesAccountHeaderGrid>
        );
    }

    return (
        <Styled.SharesAccountHeaderGrid>
            <Styled.SharesAccountHeaderTopRow>
                <Styled.SharesAccountHeaderTitle $alignTitleLeft={alignTitleLeft}>{t("fund.shareFund")}</Styled.SharesAccountHeaderTitle>
                <Styled.SharesAccountHeaderRow>
                    <Styled.SharesAccountHeaderLabel>{t("fund.value")}</Styled.SharesAccountHeaderLabel>
                    <Styled.SharesAccountHeaderValue>
                        {NumberToCZKExtraDigits(cashValue ?? 0, 2)}
                    </Styled.SharesAccountHeaderValue>
                </Styled.SharesAccountHeaderRow>
            </Styled.SharesAccountHeaderTopRow>

            {!!uninvestedAmount && (
                <Styled.SharesAccountHeaderTopRow>
                    <Styled.SharesAccountHeaderTitle $alignTitleLeft={alignTitleLeft}>{t("fund.uninvestedAmount")}</Styled.SharesAccountHeaderTitle>
                    <Styled.SharesAccountHeaderRow>
                        <Styled.SharesAccountHeaderLabel>{t("fund.value")}</Styled.SharesAccountHeaderLabel>
                        <Styled.SharesAccountHeaderValue>
                            {NumberToCZKExtraDigits(uninvestedAmount, 2)}
                        </Styled.SharesAccountHeaderValue>
                    </Styled.SharesAccountHeaderRow>
                </Styled.SharesAccountHeaderTopRow>
            )}

            <Styled.SharesAccountHeaderTopRow>
                <Styled.SharesAccountHeaderTitleRow>
                    <Styled.SharesAccountHeaderTitle $alignTitleLeft={alignTitleLeft}>{t("fund.buyback")}</Styled.SharesAccountHeaderTitle>
                    <InfoIconModalConfirm title={t("fund.buyback")} content={t("fund.buybackInfo")} />
                </Styled.SharesAccountHeaderTitleRow>
                <Styled.SharesAccountHeaderRow>
                    <Styled.SharesAccountHeaderLabel>{t("fund.value")}</Styled.SharesAccountHeaderLabel>
                    <Styled.SharesAccountHeaderValue>
                        {NumberToCZKExtraDigits(surrenderValue ?? 0, 2)}
                    </Styled.SharesAccountHeaderValue>
                </Styled.SharesAccountHeaderRow>
            </Styled.SharesAccountHeaderTopRow>
        </Styled.SharesAccountHeaderGrid>
    );
};
